/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestDev from '@/utils/requestDev'

import {  APICoreV2, APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')
export function listData(params) {
  return requestDev({
      url: APIReportPHP() + '/window24hours/list-data',
      method: 'POST',
      data: qs.stringify(params)
  })
}

export function downloadExcelContact(params) {
  return requestDev({
    url: APIReportPHP() + '/window24hours/download-excel-contact',
    method: 'POST',
    data: qs.stringify(params)

  })
}
export function downloadExcelBc(params) {
  return requestDev({
    url: APIReportPHP() + '/window24hours/download-excel-bc',
    method: 'POST',
    data: qs.stringify(params)
  })
}


// WEBPACK FOOTER //
// ./src/api/window24hours.js